import React, { useEffect } from 'react'

import { Loader } from '@pb/components'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { EXTERNAL_ROUTES } from 'App/constants'
import appSelectors from 'App/duck/selectors'

const PrivateRoute: React.FC<any> = ({ authorized, ...restProps }) => {
  useEffect(() => {
    if (!authorized) {
      window.location.replace(EXTERNAL_ROUTES.login)
    }
  }, [authorized])

  return authorized ? <Route {...restProps} /> : <Loader />
}

const mapStateToProps: any = (state) => {
  const isSignedIn = appSelectors.getIsSignedIn(state)
  const isUnauthorized = appSelectors.getIsUnauthorized(state)

  return {
    authorized: isSignedIn && !isUnauthorized,
  }
}

export default connect(mapStateToProps)(PrivateRoute)
